<div class="book-welcome-call">
  <div class="book-welcome-call__wrapper">
    <div class="book-welcome-call__image">
      <img
        ngSrc="assets/images/question.webp"
        alt="question"
        width="129"
        height="104"
        priority
      />
    </div>
    <div class="book-welcome-call__content">
      <p class="book-welcome-call__content__title">
        Need help booking your first shift?
      </p>
      <p>
        Booking your first {{ companyAlternativeShortDescriptor }} shift is an
        exciting step in your journey with us but you may have a few questions
        before you get started. That’s why we offer welcome calls to run through
        everything you need to know, and give you a chance to ask any questions
        you may have!
      </p>
      <p>
        Why not
        <a routerLink="/dashboard/first-shift" class="text-link"
          >book a welcome call</a
        >
        to help get you get started?
      </p>
    </div>
  </div>
</div>
